import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { AxiosError } from "../components/sessionexpiry";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { iphistry } from "../redux/InitiatepayoutSlice";
import { senderaccounthistry } from "../redux/InitiatepayoutSlice";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon
} from '@heroicons/react/20/solid';
import { X } from "lucide-react";
import "./Dashboard.css";

const AccountWhitelist = () => {
  const [showIpModal, setShowIpModal] = useState(false);
  const [showAccountSlide, setShowAccountSlide] = useState(false);
  const [ipValue, setIpValue] = useState("");
  const [error, setError] = useState("");

  const location = useLocation(); // Get the location object
  const { id } = location.state || {}; // Extract state from location

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  //console.log("User ID:", user_id);

  //console.log("ID from location state:", id);

  const [accountForm, setAccountForm] = useState({
    name: "",
    number: "",
    ifsc: "",
    branch: "",
    cheque: null,
  });

  const [accountErrors, setAccountErrors] = useState({});

  // IP address validation function
  const isValidIP = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return ipRegex.test(ip);
  };

  const handleIpSubmit = (e) => {
    e.preventDefault();

    if (!ipValue.trim()) {
      setError("IP address is required");
      return;
    }

    if (!isValidIP(ipValue)) {
      setError("Please enter a valid IP address");
      return;
    }

    setError("");
    //console.log("Valid IP submitted:", ipValue);
    setShowIpModal(false);
    setIpValue("");
    //console.log("Valid IP submitted:", ipAddress);
    updateData(0);
  };

  const handleAccountInputChange = (e) => {
    const { name, value } = e.target;
    setAccountForm({ ...accountForm, [name]: value });
    setAccountErrors({ ...accountErrors, [name]: "" });
  };

  const handleChequeUpload = (e) => {
    const file = e.target.files[0];
    setAccountForm({ ...accountForm, cheque: file });
    setAccountErrors({ ...accountErrors, cheque: "" });
  };

  const validateAccountForm = () => {
    const errors = {};
    //const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (!accountForm.name.trim()) errors.name = "Sender name is required.";
    if (!accountForm.number.trim())
      errors.number = "Account number is required.";
    if (!accountForm.ifsc.trim()) {
      errors.ifsc = "IFSC code is required.";
    }
    if (!accountForm.branch.trim()) errors.branch = "Bank name is required.";
    if (!accountForm.cheque)
      errors.cheque = "Please upload a cancelled cheque.";
    else if (accountForm.cheque && accountForm.cheque.size > 1 * 1024 * 1024) {
      errors.cheque = "Cheque image must be less than 1MB.";
    }
    else if (accountForm.cheque && !accountForm.cheque.name.match(/\.(jpg|jpeg|png)$/i)) {
      errors.cheque = "Cheque image must be a JPG or PNG file.";
    }


    return errors;
  };

  // const handleAccountSubmit = (e) => {
  //   e.preventDefault();
  //   const errors = validateAccountForm();

  //   if (Object.keys(errors).length > 0) {
  //     setAccountErrors(errors);
  //     return;
  //   }

  //   //console.log("✅ Submitted data:", accountForm);

  //   setShowAccountSlide(false);
  //   setAccountForm({
  //     name: "",
  //     number: "",
  //     ifsc: "",
  //     branch: "",
  //     cheque: null,
  //   });
  //   setAccountErrors({});
  // };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //const location = useLocation();  // Get the location object
  //const { id } = location.state || {};  // Extract state from location

  // update
  const updateData = async (status) => {
    try {
      // 1. Check how many active entries this user has
      const countQuery = JSON.stringify({
        Dname: "payout",
        Tname: "ip_whitelist",
        Cname: ["count(*)"],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "status",
            operator: "in",
            value: ["1", "0"], // Active entries
          },
        ],
        Limit: "10",
        Offset: "0",
      });

      const encryptedCount = encrypt(countQuery);
      const countRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedCount },
        navigate
      );

      const decryptedCount = JSON.parse(decrypt(countRes).replace(/\\"/g, '"'));
      const activeCount = parseInt(decryptedCount[1]["count(*)"] || "0");

      if (activeCount >= 3) {
        toast.error("Only 3 active IPs are allowed per merchant.");
        // setTimeout(() => {
        //   window.location.reload(); // Refresh the page to show updated accounts
        // }, 1500);
        return false;
      }

      // 2. Check if this IP is already used by another merchant
      const ipCheckQuery = JSON.stringify({
        Dname: "payout",
        Tname: "ip_whitelist",
        Cname: ["mid", "status"],
        Where: [
          {
            column: "ip",
            operator: "=",
            value: ipValue,
          },
          {
            column: "status",
            operator: "in",
            value: ["1", "0"], // Active or pending IPs
          },
        ],
        Limit: "10",
        Offset: "0",
      });

      const encryptedIP = encrypt(ipCheckQuery);
      const ipCheckRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedIP },
        navigate
      );

      const ipResult = JSON.parse(decrypt(ipCheckRes).replace(/\\"/g, '"'));

      if (ipResult.length > 1 && ipResult[1].mid !== id) {
        toast.error("This IP is already in use by another merchant.");
        return false;
      }
      if (ipResult.length > 1 && ipResult[1].mid === id) {
        toast.error("This IP is already Submitted.");
        return false;
      }

      // 3. If validations pass, proceed to update
      const updateJson = JSON.stringify({
        Dname: "payout",
        Tname: "ip_whitelist",
        Values: {
          mid: user_id,
          ip: ipValue,
          status: status,
        },
      });

      //console.log("Final JSON:", updateJson);

      const encrypted = encrypt(updateJson);

      const response = await makeAuthenticatedRequest(
        "POST",
        "/insert",
        { encrypted: encrypted },
        navigate
      );

      //    // Add validation for the response
      // if (!response) {
      //   throw new Error("No response received from server");
      // }

      const decryptdata = decrypt(response);

      //    // Check if decryption failed
      // if (decryptdata === "DECRYPTION_FAILED") {
      //   throw new Error("Decryption failed - invalid data received");
      // }

      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));

      if (jsonArray["Status count"] === "200") {
        toast.success("IP updated successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1000); // optional delay for toast visibility
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      AxiosError(navigate, error);
      console.error("Error updating data:", error);
    }
  };

  //const [loading, setLoading] = useState(false);

  const senderAccounts = useSelector(
    (state) => state.Initiatepayout.senderaccountlist
  );

  const fetchSenderAccounts = async () => {
    try {
      const requestData = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts", // Adjust table name as needed
        Cname: [
          "mid",
          "Sender_Name",
          "Sender_Account",
          "Sender_IFSC",
          "Sender_Bank",
          "status",
          "cancelled_cheque",
        ],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "status",
            operator: "in",
            value: ["1", "0"], // Active accounts
          },
        ],
        Order: { id: "desc" },
        Limit: "10",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );

      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      dispatch(senderaccounthistry(jsonArray));
    } catch (err) {
      console.error("Error fetching sender accounts:", err);
      AxiosError(navigate, err);
    }
  };


  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "payout",
          Tname: "ip_whitelist",
          Cname: ["mid", "ip", "status"],
          Where: [
            {
              column: "mid",
              operator: "=",
              value: user_id,
            },
            {
              column: "status",
              operator: "in",
              value: ["0", "1"],
            },
          ],
          Order: { id: "desc" },
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        dispatch(iphistry(jsonArray));
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };

    fetchProfileData();
    //fetchSenderAccounts();
  }, [dispatch, user_id, navigate]);

  const ip = useSelector((state) => state.Initiatepayout.iplist);
  const ip_details = ip && ip.length > 0 ? ip : [];

  //console.log("IP Details:", ip_details);

  const account_details =
    senderAccounts && senderAccounts.length > 0 ? senderAccounts : [];

  const handleViewFile = (filePath) => {
    if (filePath) {
      const fileURL = `https://merchant-image.caroset.in/images${filePath.startsWith("/") ? filePath : "/" + filePath
        }`;
      window.open(fileURL, "_blank");
    }
  };

  const updateSenderAccount = async (accountData) => {
    try {
      // 1. Check how many active accounts this user has
      const countQuery = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts",
        Cname: ["count(*)"],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "status",
            operator: "in",
            value: ["1", "0"], // Active accounts
          },
        ],
        Limit: "10",
        Offset: "0",
      });

      const encryptedCount = encrypt(countQuery);
      const countRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedCount },
        navigate
      );

      const decryptedCount = JSON.parse(decrypt(countRes).replace(/\\"/g, '"'));
      const activeCount = parseInt(decryptedCount[1]["count(*)"] || "0");

      if (activeCount >= 3) {
        toast.error("Only 3 active accounts are allowed per merchant.");

        return false;
      }

      // 2. Check if this account is already used
      const accountCheckQuery = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts",
        Cname: ["mid", "status"],
        Where: [
          {
            column: "Sender_Account",
            operator: "=",
            value: accountData.number,
          },
          {
            column: "Sender_IFSC",
            operator: "=",
            value: accountData.ifsc,
          },
          {
            column: "status",
            operator: "=",
            value: "1",
          },
        ],
        Limit: "10",
        Offset: "0",
      });

      const encryptedAccount = encrypt(accountCheckQuery);
      const accountCheckRes = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedAccount },
        navigate
      );

      const accountResult = JSON.parse(
        decrypt(accountCheckRes).replace(/\\"/g, '"')
      );

      if (accountResult.length > 1 && accountResult[1].mid !== user_id) {
        toast.error("This account is already in use by another merchant.");
        return false;
      }

      // 3. First insert the account details without cheque
      const initialUpdateJson = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts",
        Values: {
          mid: user_id,
          Sender_Name: accountData.name,
          Sender_Account: accountData.number,
          Sender_IFSC: accountData.ifsc,
          Sender_Bank: accountData.branch,
          status: "0", // Set to 0 initially until cheque is uploaded
        },
      });

      const encryptedInitial = encrypt(initialUpdateJson);
      const initialResponse = await makeAuthenticatedRequest(
        "POST",
        "/insert",
        { encrypted: encryptedInitial },
        navigate
      );

      // Add validation for the response
      if (!initialResponse) {
        throw new Error("No response received from server");
      }

      const initialDecryptdata = decrypt(initialResponse);
      // Check if decryption failed
      if (initialDecryptdata === "DECRYPTION_FAILED") {
        throw new Error("Decryption failed - invalid data received");
      }
      const initialJsonArray = JSON.parse(
        initialDecryptdata.replace(/\\"/g, '"')
      );

      if (initialJsonArray["Status count"] !== "200") {
        toast.error("Failed to create account record");
        return false;
      }

      // 4. Get the newly created account ID to upload the cheque
      const getAccountIdQuery = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts",
        Cname: ["id"],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "Sender_Account",
            operator: "=",
            value: accountData.number,
          },
          {
            column: "Sender_IFSC",
            operator: "=",
            value: accountData.ifsc,
          },
          {
            column: "status",
            operator: "=",
            value: "0",
          },
        ],
        Order: { id: "desc" },
        Limit: "1",
        Offset: "0",
      });

      const encryptedIdQuery = encrypt(getAccountIdQuery);
      const idResponse = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted: encryptedIdQuery },
        navigate
      );

      const idData = JSON.parse(decrypt(idResponse).replace(/\\"/g, '"'));
      const accountId = idData[1]?.id;

      if (!accountId) {
        toast.error("Failed to retrieve account ID for cheque upload");
        return false;
      }

      // 5. Upload the cancelled cheque
      if (accountData.cheque) {
        const formData = new FormData();
        formData.append("cancelled_cheque", accountData.cheque);

        const token = sessionStorage.getItem("token");
        const uploadResponse = await axios.post(
          `https://merchant-uat.caroset.in/sender/cancel/cheque/upload/${accountId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (uploadResponse.status !== 200) {
          throw new Error("Failed to upload cancelled cheque");
        }
      }

      toast.success("Account added successfully");
      setTimeout(() => {
        window.location.reload(); // Refresh the page to show updated accounts
      }, 1500);

      return true;
    } catch (error) {
      console.error("Error updating account:", error);
      toast.error(error.message || "Failed to add account");
      return false;
    }
  };

  const handleAccountSubmit = async (e) => {
    e.preventDefault();
    const errors = validateAccountForm();

    if (Object.keys(errors).length > 0) {
      setAccountErrors(errors);
      return;
    }

    const success = updateSenderAccount(accountForm);

    if (success) {
      setShowAccountSlide(false);
      setAccountForm({
        name: "",
        number: "",
        ifsc: "",
        branch: "",
        cheque: null,
      });
      setAccountErrors({});

      // Refresh the account list
      const requestData = JSON.stringify({
        Dname: "payout",
        Tname: "payout_senderaccounts",
        Cname: [
          "mid",
          "Sender_Name",
          "Sender_Account",
          "Sender_IFSC",
          "Sender_Bank",
          "cancelled_cheque",
          "status",
        ],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
          {
            column: "status",
            operator: "=",
            value: "1",
          },
        ],
        Order: { id: "desc" },
        Limit: "10",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );

      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      dispatch(senderaccounthistry(jsonArray));
      //console.log("Account added successfully:", senderaccounthistry);
    }
  };

  //console.log("Account Details:", account_details);

  return (
    <main
      className="main-content animate-fade-in-up mesh-bg relative overflow-hidden flex flex-col pb-4"
      style={{
        height: "calc(100vh - 4.3rem)",
        maxHeight: "calc(100vh - 1rem)",
        minHeight: "calc(100vh - 5.5rem)",
        boxSizing: "border-box",
      }}
    >
      {/* Decorative Floating Color Orbs */}
      <div className="color-orb-1 top-10 left-10 pointer-events-none" />
      <div className="color-orb-2 bottom-20 right-10 pointer-events-none" />

      {/* Header */}
      <div className="mb-6 flex-shrink-0 flex flex-col md:flex-row md:items-center md:justify-between bg-gradient-to-r from-indigo-900 via-indigo-950 to-slate-950 rounded-3xl px-8 py-5 shadow-xl relative overflow-hidden border border-slate-900 animate-fade-in-up">
        {/* Ambient light leaks inside header */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />

        <div className="relative">
          <h2 className="text-3xl font-extrabold text-white tracking-tight flex items-center gap-2">
            <span>Security Console</span>
            <span className="text-xs px-2.5 py-0.5 bg-indigo-500/25 border border-indigo-500/35 text-indigo-300 rounded-full font-bold uppercase tracking-wider animate-pulse">Protected</span>
          </h2>
          <p className="text-indigo-200/80 text-sm mt-1 font-medium">
            Configure whitelisted server IP addresses to authorize API access and payout requests safely.
          </p>
        </div>
        <nav className="mt-4 md:mt-0 relative z-10">
          <ol className="flex items-center space-x-2 text-xs font-semibold">
            <li>
              <Link to="/dashboard" className="flex items-center gap-1.5 py-2 px-3 bg-white/5 hover:bg-white/10 rounded-xl text-indigo-200 hover:text-white transition duration-200 border border-white/5">
                <span className="material-icons text-sm">dashboard</span>
                <span>Console</span>
              </Link>
            </li>
            <li className="text-indigo-400">/</li>
            <li className="text-indigo-300/60 font-normal">IP Whitelist</li>
          </ol>
        </nav>
      </div>

      {/* Main content grid */}
      <div className="container mx-auto relative z-10 flex-1 min-h-0 overflow-hidden flex flex-col">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-4 flex-1 min-h-0 overflow-hidden">
          {/* IP Whitelist Box - Left 2 Columns */}
          <div className="lg:col-span-2 flex flex-col min-h-0 h-full overflow-hidden">
            <div className="glass-panel rounded-3xl border border-slate-100 p-6 sm:p-8 flex flex-col h-full min-h-0 relative overflow-hidden animate-fade-in-up">
              {/* Accent Gradient Border top */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-600 to-violet-600"></div>

              <div className="flex-shrink-0 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <div>
                  <h3 className="text-xl font-extrabold text-slate-800">Whitelisted IP Addresses</h3>
                  <p className="text-xs text-slate-400 mt-1">Authorized server environments permitted to trigger payouts.</p>
                </div>
                <button
                  className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white font-bold text-xs px-4 py-2.5 rounded-xl shadow-md shadow-indigo-100 hover:shadow-lg hover:shadow-indigo-200 transform hover:-translate-y-0.5 active:scale-95 transition-all duration-200 flex items-center gap-1.5"
                  onClick={() => setShowIpModal(true)}
                >
                  <span>+ Add IP Address</span>
                </button>
              </div>

              <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 flex-shrink-0">
                  Active IP Restrictions ({ip_details.length > 1 ? ip_details.length - 1 : 0}/3)
                </div>

                {ip_details.length > 1 ? (
                  <div className="flex-1 overflow-y-auto pr-1 custom-scroll min-h-0 space-y-3">
                    {ip_details.slice(1).map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-4 bg-slate-50/40 backdrop-blur-sm rounded-2xl border border-slate-100 hover:bg-slate-50/80 hover:border-indigo-100 transition-all duration-300 group"
                      >
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 group-hover:scale-105 transition-transform duration-300">
                            <span className="material-icons text-xl">dns</span>
                          </div>
                          <span className="font-mono text-slate-800 text-sm font-bold tracking-wide">
                            {item.ip}
                          </span>
                        </div>

                        <div>
                          {item.status === "1" && (
                            <span className="inline-flex items-center px-3 py-1 rounded-xl text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100/60 pulse-badge-green">
                              <CheckCircleIcon className="w-3.5 h-3.5 mr-1" />
                              Active
                            </span>
                          )}
                          {item.status === "0" && (
                            <span className="inline-flex items-center px-3 py-1 rounded-xl text-xs font-bold bg-amber-50 text-amber-700 border border-amber-100/60 pulse-badge-yellow">
                              <ClockIcon className="w-3.5 h-3.5 mr-1 animate-pulse" />
                              Pending
                            </span>
                          )}
                          {item.status === "2" && (
                            <span className="inline-flex items-center px-3 py-1 rounded-xl text-xs font-bold bg-rose-50 text-rose-700 border border-rose-100/60 pulse-badge-red">
                              <XCircleIcon className="w-3.5 h-3.5 mr-1" />
                              Rejected
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex-1 flex flex-col justify-center items-center py-10">
                    <div className="w-16 h-16 rounded-3xl bg-slate-50 flex items-center justify-center text-slate-400 mb-4 border border-slate-100 shadow-inner">
                      <span className="material-icons text-3xl">gpp_maybe</span>
                    </div>
                    <p className="text-slate-500 font-bold text-sm">
                      No IPs whitelisted yet
                    </p>
                    <p className="text-slate-400 text-xs mt-1">
                      Get started by adding your server IP to restrict API access safely.
                    </p>
                    <button
                      onClick={() => setShowIpModal(true)}
                      className="mt-4 text-xs font-extrabold text-indigo-600 hover:text-indigo-800 flex items-center gap-1 hover:underline transition duration-150"
                    >
                      + Add IP Address
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Security Policy Panel - Right 1 Column */}
          <div className="lg:col-span-1 flex flex-col min-h-0 h-full overflow-hidden">
            <div className="glass-panel rounded-3xl border border-slate-100 p-6 sm:p-8 relative overflow-hidden h-full flex flex-col justify-between animate-fade-in-up">
              {/* Accent Gradient Border top */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-violet-600 to-indigo-600"></div>

              <div>
                <h3 className="text-lg font-bold text-slate-800 mb-1flex items-center gap-2">
                  <span className="material-icons text-indigo-600 text-xl">shield</span>
                  Security Policy
                </h3>
                <div className="space-y-4">
                  <div className="bg-indigo-50/40 rounded-2xl p-4 border border-indigo-100/50">
                    <h4 className="text-xs font-bold text-indigo-800 uppercase tracking-wider mb-1.5 flex items-center gap-1.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-indigo-500" />
                      Why Whitelist IPs?
                    </h4>
                    <p className="text-xs text-indigo-700/80 leading-relaxed font-medium">
                      Whitelisting IP addresses ensures that payout and settlement API commands are executed ONLY from your verified servers, preventing unauthorized calls.
                    </p>
                  </div>

                  <div className="bg-purple-50/40 rounded-2xl p-4 border border-purple-100/50">
                    <h4 className="text-xs font-bold text-purple-800 uppercase tracking-wider mb-1.5 flex items-center gap-1.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-purple-500" />
                      Active Limit
                    </h4>
                    <p className="text-xs text-purple-700/80 leading-relaxed font-medium">
                      You can whitelist up to <strong>3 active IP addresses</strong> per merchant. Ensure your server IPs do not change dynamically.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-1 pt-1 border-t border-slate-100 text-xs font-bold text-slate-400 flex items-center gap-2">
                <span className="material-icons text-emerald-500 text-sm">verified_user</span>
                <span>Enforced by Gaadiaa Guard</span>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>

    {/* IP Whitelist Modal */}
    {showIpModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in-up">
        <div className="glass-modal w-full max-w-md rounded-3xl p-8 relative overflow-hidden">
          {/* Ambient light streak */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-indigo-600 to-violet-600"></div>

          {/* Close button (X mark) */}
          <button
            onClick={() => {
              setShowIpModal(false);
              setError("");
              setIpValue("");
            }}
            className="absolute top-5 right-5 text-slate-400 hover:text-slate-600 transition-colors p-1.5 hover:bg-slate-100 rounded-xl"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="mb-6">
            <h3 className="text-xl font-extrabold text-slate-800">
              Add IP to Whitelist
            </h3>
            <p className="text-xs text-slate-400 mt-1">
              Provide the IPv4 address of your backend server environment
            </p>
          </div>

          <form onSubmit={handleIpSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                IPv4 Address
              </label>
              <input
                type="text"
                placeholder="e.g. 192.168.1.1"
                value={ipValue}
                maxLength={20}
                onChange={(e) => {
                  setIpValue(e.target.value);
                  if (error) setError("");
                }}
                className={`w-full px-4 py-3 rounded-2xl border text-sm premium-input transition-all ${
                  error
                    ? "border-rose-500 focus:ring-rose-500/20 focus:border-rose-500"
                    : "border-slate-200 bg-slate-50/50"
                }`}
              />
              {error && <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{error}</p>}
            </div>

            <div className="flex gap-3 justify-end mt-8">
              <button
                type="button"
                onClick={() => {
                  setShowIpModal(false);
                  setError("");
                  setIpValue("");
                }}
                className="flex-1 py-3 px-4 rounded-2xl border border-slate-200 text-slate-600 font-bold text-sm hover:bg-slate-50 transition duration-200 active:scale-95"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 text-white py-3 px-4 rounded-2xl font-bold text-sm shadow-md shadow-indigo-100 hover:shadow-indigo-200 hover:shadow-lg transition duration-200 active:scale-95"
              >
                Submit Request
              </button>
            </div>
          </form>
        </div>
      </div>
    )}

      {/* Account Whitelist Slide-in Panel */}
      {showAccountSlide && (
        <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/60 backdrop-blur-sm p-4 animate-fade-in-up">
          <div className="glass-modal w-full max-w-md h-full shadow-2xl p-8 overflow-y-auto relative rounded-l-3xl">
            {/* Close Button */}
            <button
              onClick={() => setShowAccountSlide(false)}
              className="absolute top-5 right-5 text-slate-400 hover:text-slate-600 transition-colors p-1.5 hover:bg-slate-100 rounded-xl"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="mb-6">
              <h3 className="text-xl font-extrabold text-slate-800">
                Add Bank Account
              </h3>
              <p className="text-xs text-slate-400 mt-1">
                Provide bank credentials to register sender account
              </p>
            </div>

            <hr className="border-slate-100 mb-6" />

            <form className="space-y-5" onSubmit={handleAccountSubmit}>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                  Account Holder Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  autoComplete="off"
                  placeholder="Enter Holder Name"
                  maxLength={70}
                  value={accountForm.name}
                  onChange={handleAccountInputChange}
                  className={`w-full px-4 py-3 rounded-2xl border text-sm premium-input transition-all ${
                    accountErrors.name
                      ? "border-rose-500 focus:ring-rose-500/20 focus:border-rose-500"
                      : "border-slate-200 bg-slate-50/50"
                  }`}
                />
                {accountErrors.name && (
                  <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{accountErrors.name}</p>
                )}
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                  Account Number<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="number"
                  autoComplete="off"
                  placeholder="Enter Account Number"
                  maxLength={20}
                  value={accountForm.number}
                  onChange={handleAccountInputChange}
                  className={`w-full px-4 py-3 rounded-2xl border text-sm premium-input transition-all ${
                    accountErrors.number
                      ? "border-rose-500 focus:ring-rose-500/20 focus:border-rose-500"
                      : "border-slate-200 bg-slate-50/50"
                  }`}
                />
                {accountErrors.number && (
                  <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{accountErrors.number}</p>
                )}
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                  IFSC Code<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="ifsc"
                  autoComplete="off"
                  placeholder="Enter IFSC Code"
                  maxLength={11}
                  value={accountForm.ifsc}
                  onChange={handleAccountInputChange}
                  className={`w-full px-4 py-3 rounded-2xl border text-sm premium-input transition-all ${
                    accountErrors.ifsc
                      ? "border-rose-500 focus:ring-rose-500/20 focus:border-rose-500"
                      : "border-slate-200 bg-slate-50/50"
                  }`}
                />
                {accountErrors.ifsc && (
                  <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{accountErrors.ifsc}</p>
                )}
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                  Bank Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="branch"
                  autoComplete="off"
                  placeholder="Enter Bank Name"
                  maxLength={45}
                  value={accountForm.branch}
                  onChange={handleAccountInputChange}
                  className={`w-full px-4 py-3 rounded-2xl border text-sm premium-input transition-all ${
                    accountErrors.branch
                      ? "border-rose-500 focus:ring-rose-500/20 focus:border-rose-500"
                      : "border-slate-200 bg-slate-50/50"
                  }`}
                />
                {accountErrors.branch && (
                  <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{accountErrors.branch}</p>
                )}
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                  Upload Cancelled Cheque<span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={handleChequeUpload}
                  className={`w-full border rounded-2xl p-3 text-sm border-slate-200 bg-slate-50/50 ${
                    accountErrors.cheque ? "border-rose-500" : ""
                  }`}
                />
                {accountErrors.cheque && (
                  <p className="text-rose-600 text-xs font-bold mt-2 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse" />{accountErrors.cheque}</p>
                )}
              </div>

              <div className="flex gap-3 justify-end mt-8">
                <button
                  type="button"
                  onClick={() => {
                    setShowAccountSlide(false);
                    setAccountForm({
                      name: "",
                      number: "",
                      ifsc: "",
                      branch: "",
                      cheque: null,
                    });
                    setAccountErrors({});
                  }}
                  className="flex-1 py-3 px-4 rounded-2xl border border-slate-200 text-slate-600 font-bold text-sm hover:bg-slate-50 transition duration-200 active:scale-95"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 text-white py-3 px-4 rounded-2xl font-bold text-sm shadow-md shadow-indigo-100 hover:shadow-indigo-200 hover:shadow-lg transition duration-200 active:scale-95"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  );
};

export default AccountWhitelist;
